import { API_PUBLIC_HOST } from "@/_constant";
import api from "./request";
import { LeadStatus, PurchaseRequestProductDetails } from "@/types";

export function fetchPurchaseRequest(payload: any) {
    const url = `${API_PUBLIC_HOST}/userAccessProfile/listPurchaseOrders`;
    return api.post(url, payload);
}

export function savePurchaseRequest(payload: PurchaseRequestProductDetails) {
    const url: string = `${API_PUBLIC_HOST}/userAccessProfile/addPurchaseOrder`;
    return api.post(url, payload);
}

export function deletePurchaseRequest(purchaseRequestId: number | string) {
    const url: string = `${API_PUBLIC_HOST}/userAccessProfile/deletePurchaseOrder?purchaseOrderId=${purchaseRequestId}`;
    return api.delete(url);
}

export function initiatePurchaseRequestPayment(payload:any){
    const url : string = `${API_PUBLIC_HOST}/userAccessProfile/initiatePaymentPurchaseOrder`;
    return api.post(url, payload);
}

export function savePurchaseRequestPayment(payload:any){
    const url:string = `${API_PUBLIC_HOST}/userAccessProfile/submitPaymentPurchaseOrder`;
    return api.post(url, payload);
}

export function updatePurchaseRequestStatus(purchaseOrderId: string, status: LeadStatus){
    const url:string = `${API_PUBLIC_HOST}/userAccessProfile/updatePurchaseOrderStatus`;
    const request = {
        id: purchaseOrderId,
        status: status
    };
    return api.post(url, request);
}

export function updatePurchaseRequestAppointmentStatus(purchaseOrderId: string, status: string){
    const url:string = `${API_PUBLIC_HOST}/userAccessProfile/updatePurchaseOrderStatus`;
    const request = {
        id: purchaseOrderId,
        appointmentStatus: status
    };
    return api.post(url, request);
}